import type { CSSProperties, ReactNode } from "react";
import { Link } from "react-router";
import saraPookaPng from "./media/sara_and_pooka_sm.png";
import saraPookaSvg from "./media/sara_and_pooka_sm.svg";

// The SVG embeds a WebP raster, which Safari before 14 cannot decode: the
// source is typed image/webp so those browsers skip it for the PNG.
export function SaraPookaImage({
  size,
  alt = "",
  className,
}: {
  size: number;
  alt?: string;
  className?: string;
}) {
  return (
    <picture className={className}>
      <source srcSet={saraPookaSvg} type="image/webp" />
      <img
        src={saraPookaPng}
        alt={alt}
        width={size}
        height={size}
        loading="lazy"
        decoding="async"
        className="object-contain"
        style={{ width: size, height: size }}
      />
    </picture>
  );
}

export function BrandLogo({
  large = false,
  onNavigate,
}: {
  large?: boolean;
  onNavigate?: () => void;
}) {
  return (
    <Link
      to="/"
      onClick={onNavigate}
      className="flex items-center"
      aria-label="Go to Read by Ear home page"
    >
      <SaraPookaImage
        size={large ? 120 : 48}
        alt="Sara and Pooka"
        className="shrink-0"
      />
    </Link>
  );
}

const SMALL_CAPS: CSSProperties = { fontVariant: "small-caps" };

export function SmallCaps({ children }: { children: ReactNode }) {
  return <span style={SMALL_CAPS}>{children}</span>;
}
